function UnavailabilitiesItem({ Data }) {
  return (
    <>
      <div className="card mb-2  ">
        <div className="px-2 py-2  rounded  d-flex justify-content-between align-items-center">
          <div className="">
            <span className="badge bg-danger">Indisponilité(s)</span>
            <p className="text-muted">
              {Data.startDate},{Data.startTime} - {Data.endDate},{Data.endTime}
            </p>
          </div>

          <i class="bi bi-chevron-double-right"></i>
        </div>
      </div>
    </>
  );
}

export default UnavailabilitiesItem;
